export const groupTypeMixin = {
  data() {
    return {};
  },
  methods: {
    checkFiltersInSession(id) {
      let appliedFilter = this.$store.getters["tickets/appliedFilter"];
      for (var key in appliedFilter) {
        if (appliedFilter[key] && appliedFilter[key].length !== 0) {
          if (key === "group_id_in") {
            let index = appliedFilter[key].indexOf(id);
            if (index > -1) {
              appliedFilter[key].splice(index, 1);
            }
          } else if (key === "ticket_type_id_in") {
            let index = appliedFilter[key].indexOf(id);
            if (index > -1) {
              appliedFilter[key].splice(index, 1);
            }
          }
        }
      }
      this.$store.dispatch("tickets/appliedFilter", [appliedFilter]);
    },
  },
};
